import React from "react";
import { Link } from "react-router-dom";
import Service from '../../service/Service';
import * as actions from '../Actions';

const service = new Service();

export default function MoreWinners({ eleRef, moreWinnersData }) {
    return (
        <div>
        {moreWinnersData && moreWinnersData.length > 0 ?
            <div className="allWinners">
                {moreWinnersData && moreWinnersData.length > 0 && moreWinnersData.map((value, index) =>
                <ul className="participant-list" key ={value.index} >
                    {value.records && value.records.map((result, index)=>
                    <li className="participant" key={result.index}>
                        <a href={`/memories/photodetails/${result.id}`} className="parti-img" key={result.id}>
                            <img src={result.image_url.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} onError={(e) => (e.target.src = result.image_url.replace("http://", "https://"))} />
                            <div className="winnertag">
                                {/* <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/contest-winner-icon.svg'} alt="winner" title="winner" /> */}
                            </div>
                        </a>
                        <div id="winner-nm" className="winner-name M13_42">{result.prize ? result.userName : ''}</div>
                        <div className="prize-won R13_9e">{result.prize ? result.prize : ''}</div>
                    </li>
                    )}
                </ul>
                )}
            </div>
            : null
            }
        </div>
    )
}
